export default String.raw`
.quantity{
    border: 1px solid #767676;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    background: $inputsBgColor;
    width: 107px;
    height: 40px;
    padding: 10px;
    &__input{
        background: transparent;
        font-size: 14px; 
        line-height: 20px; 
        border: none;
        width: 49px;
        height: 18px;
        text-align: center;
    }
    &__minus, &__plus{
        border: none;
        background: transparent;
        width: 18px;
        padding: 0;
        cursor: pointer;
        .icon{
            width: 11px;
            height: 11px;
            fill: #959595;
        }
    }

    .disabled-js {
        &:focus-visible {
            outline: none !important;
        }
    }
}
`